export const applicationsConstants = {
    APPLICATIONS_GET_DETAILS_REQUEST: 'APPLICATIONS_GET_DETAILS_REQUEST',
    APPLICATIONS_GET_DETAILS_SUCCESS: 'APPLICATIONS_GET_DETAILS_SUCCESS',
    APPLICATIONS_GET_DETAILS_FAILURE: 'APPLICATIONS_GET_DETAILS_FAILURE',

    APPLICATIONS_CLEAR: 'APPLICATIONS_CLEAR',
};
